import React from 'react';
import Layout from 'Components/Layout';
import PageHeader from 'Components/PageHeader';
import styles from 'Components/AddRulePage/AddRuleForm.css';
import ButtonGroup from 'Components/ButtonGroup';
import { Button } from '@brighterion/br-ui';
import { handleKeyEvent, handleOnClickEvent } from 'Utils';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQueryParam } from 'Hooks/useQueryParam';
import RuleTester from 'Components/AddRulePage/RuleTester';
import useGetConclusionFlags from 'Hooks/query-hooks/useGetConclusionFlags';
import useGetParameters from 'Hooks/query-hooks/parameters/useGetParameters';
import useGetList from 'Hooks/query-hooks/list/useGetList';
import RouteLoading from 'Components/RouteLoading/RouteLoading';
import errorController from 'Components/ErrorScreens/errorController';

const RuleTesterLayout = () => {
    const history = useHistory();
    const { t } = useTranslation();
    const { ruleId } = useParams<{ ruleId: string }>();
    const {
        parsed: { selectedRowId }
    } = useQueryParam();
    const { data: conclusionFlagListData } = useGetConclusionFlags();
    const parametersAPI = useGetParameters({
        queryParams: {
            status: JSON.stringify(['active']),
            order: 'asc'
        }
    });
    const listsAPI = useGetList();
    if (parametersAPI.isLoading || parametersAPI.isFetching || listsAPI.isLoading || listsAPI.isFetching) {
        return <RouteLoading />;
    }

    if (parametersAPI.isError || listsAPI.isError) {
        const { errorCmp } = errorController([parametersAPI.error, listsAPI.error]);
        return errorCmp;
    }
    const handleBack = () => {
        if (selectedRowId) {
            // after editing an existing rule
            history.push(`/global-rules?selectedRowId=${selectedRowId}`);
        } else {
            // after creating a new rule
            history.push('/global-rules');
        }
    };

    return (
        <Layout>
            <PageHeader>
                <PageHeader.Left className={styles.titleText}>{t('viewRuleTest', { ruleId })}</PageHeader.Left>
                <PageHeader.Right className={styles.rightButtonContainer}>
                    <ButtonGroup direction='row'>
                        <Button
                            dataTestId='addForm-cancel-btn'
                            variant='tertiary'
                            size='medium'
                            onKeyDown={handleKeyEvent(handleBack)}
                            onClick={handleOnClickEvent(handleBack)}
                            iconName='arrow-left-1'
                        >
                            {t('Back To Manage Rules')}
                        </Button>
                    </ButtonGroup>
                </PageHeader.Right>
            </PageHeader>
            <RuleTester
                selectedRuleId={ruleId}
                parameterData={parametersAPI?.data}
                listData={listsAPI?.data}
                conclusionFlagListData={conclusionFlagListData}
                mode='read'
            />
        </Layout>
    );
};

export default RuleTesterLayout;
